<template>
  <div>
    <v-layout row wrap class="mb-3">
      <v-flex xs12 class="mt-4 px-0">
        <h5 class="border-top font-weight-bold">
          Phiếu chi {{ index + 1 }}
          <v-btn @click="removeReceipt(index)" color="red" flat small v-if="!(receipt_state._id && receipt_state.type === ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED)">
            Xóa
            <v-icon>delete</v-icon>
          </v-btn>
        </h5>
      </v-flex>
      <v-flex xs12 md3>
        <v-select
          :items="expense_type_options"
          :disabled="loading.submit || (receipt_state._id && receipt_state.type === ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED)"
          v-model="receipt_state.type"
          :rules="[rules.required]"
          prepend-icon="list"
          label="Loại chi"
        ></v-select>
      </v-flex>
      <v-flex xs12 md3>
        <v-select
          label="Tòa nhà"
          :disabled="loading.submit || ![ACCOUNT_TYPES.RETURN_DEPOSIT, ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED, ACCOUNT_TYPES.WATER, ACCOUNT_TYPES.ELECTRICITY].includes(receipt_state.type) || (receipt_state._id && receipt_state.type === ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED)"
          v-model="receipt_state.building"
          :items="list_building"
          prepend-icon="domain"
          :rules="
            [ACCOUNT_TYPES.RETURN_DEPOSIT, ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED].includes(receipt_state.type) ? [rules.required] : []
          "
          @change="receipt_state.room_id = ''"
          required
        ></v-select>
      </v-flex>
      <v-flex xs12 md3>
        <v-autocomplete
          label="Số phòng"
          :disabled="loading.submit || ![ACCOUNT_TYPES.RETURN_DEPOSIT, ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED].includes(receipt_state.type) || (receipt_state._id && receipt_state.type === ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED)"
          v-model="receipt_state.room_id"
          :items="room_ids"
          item-text="room_id"
          item-value="rooms_id"
          prepend-icon="meeting_room"
          :rules="
            [ACCOUNT_TYPES.RETURN_DEPOSIT, ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED].includes(receipt_state.type) ? [rules.required] : []
          "
          required
          @change="receipt_state.type === ACCOUNT_TYPES.RETURN_DEPOSIT ? findReceiptReturnDeposit() : findCancelledDeposit()"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field
          label="Mã phiếu chi"
          v-model="receipt_state.receipt_id"
          prepend-icon="account_box"
          disabled
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field
          label="Số tiền chi"
          :disabled="loading.submit || !receipt_state.type || (receipt_state._id && receipt_state.type === ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED) || (receipt_state.type === ACCOUNT_TYPES.RETURN_DEPOSIT)"
          v-model="receipt_state.amount"
          prepend-icon="money"
          :rules="[rules.required]"
          small
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-menu
          :close-on-content-click="false"
          v-model="menu_date_created"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          disabled
        >
          <v-text-field
            slot="activator"
            v-model="receipt_state.date_created"
            label="Ngày tạo phiếu"
            disabled
            prepend-icon="event"
            :rules="[rules.required]"
          ></v-text-field>
          <v-date-picker
            locale="vi-VI"
            v-model="receipt_state.date_created"
            @input="menu_date_created = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md3
          v-if="
            [
              ACCOUNT_TYPES.RETURN_LOAN,
            ].includes(receipt_state.type)
          "
        >
          <v-select
          :items="LOAN_OBJECT_OPTIONS"
          :disabled="loading.submit || loading.form"
          :rules="[rules.required]"
          v-model="receipt_state.loan_object"
          prepend-icon="person"
          label="Đối tượng"
        ></v-select>
      </v-flex>
      <v-flex xs12 md3
          v-if="receipt_state.type === ACCOUNT_TYPES.MANAGEMENT_STAFF_SALARY"
        >
          <v-select
          :items="SALARY_RECIPIENT_OPTIONS"
          :disabled="loading.submit"
          :rules="[rules.required]"
          v-model="receipt_state.salary_recipient"
          prepend-icon="person"
          item-text="text"
          item-value="value"
          label="Đối tượng chi lương"
        ></v-select>
      </v-flex>
      <v-flex xs12 md3
          v-if="receipt_state.type === ACCOUNT_TYPES.LAND_RENT"
        >
          <v-select
          :items="LAND_RENT_LOCATION_OPTIONS"
          :disabled="loading.submit"
          :rules="[rules.required]"
          v-model="receipt_state.land_rent_location"
          prepend-icon="location_on"
          item-text="text"
          item-value="value"
          label="Vị trí thuê đất"
        ></v-select>
      </v-flex>
      <v-flex xs12 md3
          v-if="receipt_state.type === ACCOUNT_TYPES.MATERIAL_PURCHASE"
        >
          <v-select
          :items="MATERIAL_PURCHASE_TYPE_OPTIONS"
          :disabled="loading.submit"
          :rules="[rules.required]"
          v-model="receipt_state.material_purchase_type"
          prepend-icon="build"
          item-text="text"
          item-value="value"
          label="Loại chi mua vật tư"
        ></v-select>
      </v-flex>
      <v-flex xs12 md3
          v-if="receipt_state.type === ACCOUNT_TYPES.REPAIR"
        >
          <v-select
          :items="REPAIR_EXPENSE_TYPE_OPTIONS"
          :disabled="loading.submit"
          :rules="[rules.required]"
          v-model="receipt_state.repair_expense_type"
          prepend-icon="handyman"
          item-text="text"
          item-value="value"
          label="Loại chi sửa chữa"
        ></v-select>
      </v-flex>

      <v-flex xs12 md3
          v-if="receipt_state.type === ACCOUNT_TYPES.LOAN_INTEREST"
        >
          <v-select
          :items="LOAN_OBJECT_OPTIONS"
          :disabled="loading.submit"
          :rules="[rules.required]"
          v-model="receipt_state.loan_interest_object"
          prepend-icon="account_balance"
          item-text="text"
          item-value="value"
          label="Đối tượng chi lãi vay"
        ></v-select>
      </v-flex>
      <v-flex xs12 md12>
        <v-text-field
          label="Ghi chú"
          v-model="receipt_state.note"
          prepend-icon="event_note"
          :disabled="loading.submit || !receipt_state.type || (receipt_state._id && receipt_state.type === ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED)"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 v-if="alert.show">
        <v-alert :value="alert.show" :type="alert.type" outline>
          {{ alert.text }}
        </v-alert>
      </v-flex>
      <!-- <v-flex
        xs12
        v-if="
          receipt_state.type === 'return_deposit' && list_return_deposits.length
        "
      >
        <v-radio-group v-model="chosen_return_deposit" row>
          <v-radio
            v-for="return_deposit in list_return_deposits"
            :key="return_deposit.check_out_id"
            :label="
              `Phiếu trả phòng: ${
                return_deposit.check_out_id
              } - Số tiền trả cọc: ${formatCurrency(return_deposit.amount)}`
            "
            :value="return_deposit"
            color="primary"
          ></v-radio>
        </v-radio-group>
      </v-flex> -->
      <v-flex
        xs12
        v-if="
          receipt_state.type === ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED && list_cancelled_deposits.length
        "
      >
        <v-radio-group v-model="chosen_cancelled_deposit" row>
          <v-radio
            v-for="cancelled_deposit in list_cancelled_deposits"
            :key="cancelled_deposit.receipt_id"
            :label="
              `Phiếu cọc: ${
                cancelled_deposit.receipt_id
              } - Số tiền cọc: ${formatCurrency(cancelled_deposit.deposit_amount)}`
            "
            :value="cancelled_deposit"
            color="primary"
          ></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import api from "../../../api";
import {
  list_building,
  EXPENSE_ACCOUNT_OPTIONS,
  BANK_ACCOUNT_TYPE_LIST,
  ACCOUNT_TYPES,
  LOAN_OBJECT_OPTIONS,
  SALARY_RECIPIENT_OPTIONS,
  LAND_RENT_LOCATION_OPTIONS,
  MATERIAL_PURCHASE_TYPE_OPTIONS,
  REPAIR_EXPENSE_TYPE_OPTIONS,
} from "Constants/db-config";
import {
  buildParamQuery,
  deepCopy,
  formatCurrency,
  parseCurrency,
} from "Helpers";

export default {
  name: "card-tao-phieu-chi-tu-giao-dich",
  props: {
    index: Number,
    receipt: Object,
    transaction: Object,
    totalReceiptIndex: Number,
  },
  components: {},
  data() {
    return {
      menu_date_created: false,
      loading: {
        submit: false,
      },
      formatCurrency,
      receipt_state: deepCopy(this.receipt),
      list_building,
      rules: {
        required: (value) => !!value || "Vui lòng điền thông tin này.",
      },
      expense_type_options: EXPENSE_ACCOUNT_OPTIONS.filter(
        (item) => item.text !== "Chi lương (cũ)" && item.value !== ACCOUNT_TYPES.MONTHLY_REPAIR_AND_MATERIAL_PURCHASE
      ),
      list_return_deposits: [],
      chosen_return_deposit: "",
      list_cancelled_deposits: [],
      chosen_cancelled_deposit: "",
      alert: {
        show: false,
        text: "",
        type: "error",
      },
      ACCOUNT_TYPES,
      LOAN_OBJECT_OPTIONS,
      SALARY_RECIPIENT_OPTIONS,
      LAND_RENT_LOCATION_OPTIONS,
      MATERIAL_PURCHASE_TYPE_OPTIONS,
      REPAIR_EXPENSE_TYPE_OPTIONS,
    };
  },
  computed: {
    rooms() {
      return this.$store.state.app.rooms;
    },
    room_ids() {
      return this.rooms.filter(
        (room) => room.building === this.receipt_state.building
      );
    },
  },
  created() {
    this.generateReceiptId();
  },
  watch: {
    // totalReceiptCount: function(nv) {
    //   this.receipt_state.receipt_id = `${this.transaction.bank_receipt_id}.${
    //     this.totalReceiptIndex
    //   }`;
    // },
    "receipt_state.type"(nv) {
      if (nv !== "return_deposit") {
        this.receipt_state.room_id = "";
        this.receipt_state.building = "";
        this.chosen_return_deposit = "";
      }
      if (nv !== this.ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED) {
        this.receipt_state.room_id = "";
        this.receipt_state.building = "";
        this.chosen_cancelled_deposit = "";
      }
      if ([ACCOUNT_TYPES.RETURN_DEPOSIT, ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED].includes(nv)) {
        this.receipt_state.receipt_id = `${this.transaction.bank_receipt_id}.${
          this.totalReceiptIndex
        }.TC`;
      } else if ([ACCOUNT_TYPES.RETURN_LOAN].includes(nv)) {
        this.receipt_state.receipt_id = `${this.transaction.bank_receipt_id}.${
          this.totalReceiptIndex
        }.VAY`;
      } else if ([ACCOUNT_TYPES.THIS_PERIOD_UNDISTRIBUTED_EARNINGS].includes(nv)) {
        this.receipt_state.receipt_id = `${this.transaction.bank_receipt_id}.${
          this.totalReceiptIndex
        }.LN`;
      } else if ([ACCOUNT_TYPES.MR_LONG_PAYMENT].includes(nv)) {
        this.receipt_state.receipt_id = `${this.transaction.bank_receipt_id}.${
          this.totalReceiptIndex
        }.AL`;
      } else {
        this.receipt_state.receipt_id = `${this.transaction.bank_receipt_id}.${
          this.totalReceiptIndex
        }.KHAC`;
      }

      this.alert.show = false;
    },
    "receipt_state.room_id"(nv) {
      this.chosen_return_deposit = "";
      this.chosen_cancelled_deposit = "";
    },
    "receipt_state.amount"(nv) {
      console.log("🚀 ~ nv:", nv);

      const parsedValue = parseCurrency(nv) || 0;
      console.log("🚀 ~ parsedValue:", parsedValue);

      this.receipt_state.amount = formatCurrency(parsedValue);
    },
    receipt_state: {
      handler: function(nv) {
        this.generateReceiptId();
        this.$emit("setReceiptListState", nv, this.index);
      },
      deep: true,
    },
    receipt: {
      handler: function(nv) {
        this.receipt_state = deepCopy(nv);
      },
      deep: true,
    },
    chosen_return_deposit(nv) {
      if (nv) {
        this.receipt_state.amount = formatCurrency(nv.amount);
        this.receipt_state.check_out_id = nv.check_out_id;
        this.receipt_state.return_deposit_amount = nv.amount;
      } else {
        this.receipt_state.check_out_id = "";
        this.receipt_state.amount = "";
      }
    },
    chosen_cancelled_deposit(nv) {
      if (nv) {
        this.receipt_state.amount = nv.deposit_amount.toLocaleString("vi-VI") + " ₫";
        this.receipt_state.deposit_receipt_id = nv.receipt_id;
      } else {
        this.receipt_state.amount = "";
      }
    },
  },
  methods: {
    clearInput: function() {
      this.$refs.receipt_state.reset();
      this.receipt_state.wallet_account_id = null;
      this.list_return_deposits = [];
      this.list_cancelled_deposits = [];
    },
    findReceiptReturnDeposit: async function() {
      this.alert.show = false;
      this.loading.submit = true;
      const params = {
        roomId: this.receipt_state.room_id,
        disbursementId: false,
      };
      const query = buildParamQuery(params);
      const data = await api.getListReturnDeposit(query);

      if (data.status == 200) {
        this.list_return_deposits = data.data.slice(0, 1);
        const foundDeposit = this.list_return_deposits.length ? this.list_return_deposits.find((e) => e.amount >= 0) : undefined;
        if (!foundDeposit) {
          this.alert.show = true;
          this.alert.text = `Không tìm thấy phiếu trả phòng của phòng ${
            this.receipt_state.room_id
          }`;
        } else {
          this.chosen_return_deposit = foundDeposit;
        }
      } else {
        this.alert.show = true;
        this.alert.text = "Lỗi không tìm thấy dữ liệu";
      }

      this.loading.submit = false;
    },
    findCancelledDeposit: async function() {
      this.alert.show = false;
      this.loading.submit = true;
      const params = {
        roomId: this.receipt_state.room_id,
        isDisbursedForCancel: false,
      };
      const query = buildParamQuery(params);
      const data = await api.getListCancelledDeposit(query);

      if (data.status == 200) {
        this.list_cancelled_deposits = data.data.slice(0);
        if (!this.list_cancelled_deposits.length) {
          this.alert.show = true;
          this.alert.text = `Không tìm thấy phiếu cọc đã hủy của phòng ${
            this.receipt_state.room_id
          }`;
        } else {
          this.chosen_cancelled_deposit = this.list_cancelled_deposits[0];
        }
      } else {
        this.alert.show = true;
        this.alert.text = "Lỗi không tìm thấy dữ liệu";
      }

      this.loading.submit = false;
    },
    removeReceipt: function(index) {
      this.$emit("removeReceipt", index);
    },
    generateReceiptId: function() {
      if (this.receipt_state.receipt_id) {
        return;
      }

      this.receipt_state.receipt_id = this.receipt_state.receipt_id = `${
        this.transaction.bank_receipt_id
      }.${this.totalReceiptIndex}`;
    },
  },
};
</script>

<style scoped>
.border-top {
  padding-top: 9px;
  border-top: 1px solid #ddd;
}
</style>
